import {ITagsFilter} from "../../models/ITagsFilter";

export const tagsFiltersPL: ITagsFilter[] = [
    {
        tagTitleAddiction: "Uzależnienia", statusActive: false, isActiveSelectors: [], idNavTag: 'qwe',
        tagFilters: [
            {
                title: 'Narkomania', isActive: false, idTag: '1'
            },
            {
                title: 'Alkoholizm',
                isActive: false,
                idTag: '2'
            },
            {
                title: 'Hazard', isActive: false, idTag: '3'
            },
            {
                title: 'Uzależnienie od gier',
                isActive: false,
                idTag: '4'
            },
            {
                title: 'Współuzależnienie', isActive: false, idTag: '5'
            },
            // {
            //     title: 'Seksoholizm',
            //     isActive: false,
            //     idTag: '2-6'
            // }
        ]
    },
    {
        tagTitleAddiction: "Problemy", statusActive: false, isActiveSelectors: [], idNavTag: 'ewq',
        tagFilters: [
            {title: 'Bezsenność', isActive: false, idTag: '1'},
            {
                title: 'Prześladowanie',
                isActive: false,
                idTag: '2'
            },
            {title: 'Depresja', isActive: false, idTag: '3'},
            {
                title: 'Kleptomania',
                isActive: false,
                idTag: '4'
            },
            {title: 'Niepewność', isActive: false, idTag: '5'},
            {
                title: 'Uraza',
                isActive: false,
                idTag: '6'
            },
            {title: 'Samotność', isActive: false, idTag: '7'},
            {
                title: 'PTSD',
                isActive: false,
                idTag: '8'
            },
            {title: 'Ataki paniki', isActive: false, idTag: '9'},
            {
                title: 'Zaburzenia odżywiania',
                isActive: false,
                idTag: '10'
            },
            {title: 'Lęk', isActive: false, idTag: '11'},
            {
                title: 'Pracoholizm',
                isActive: false,
                idTag: '12'
            },
            {title: 'Strata bliskiej osoby', isActive: false, idTag: '13'},
            {
                title: 'Fobie i alergie',
                isActive: false,
                idTag: '14'
            },
            {title: 'Poczucie strachu', isActive: false, idTag: '15'}
        ]
    }
]
